export default "__VITE_ASSET__DsdR3_TA__"